var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute fill-height invitation-page",style:({'background-image': ("url(" + _vm.MainBg + ")")})})}
var staticRenderFns = []

export { render, staticRenderFns }